import Vue3Toastify, { toast } from 'vue3-toastify'
import { XMarkIcon, ExclamationTriangleIcon, CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/vue/24/solid'

import 'vue3-toastify/dist/index.css'
import '@/assets/css/vue3-toastify.scss'

import { h } from 'vue'
import type { App } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()

  const resolveGLobalComponents = (instance: App<Element>) => {
    instance.use(router)
  }

  nuxtApp.vueApp.use(Vue3Toastify, {
    useHandler: resolveGLobalComponents,
    position: toast.POSITION.BOTTOM_CENTER,
    autoClose: false,
    closeOnClick: false,
    closeButton: ({ closeToast }: { closeToast: () => void }) =>
      h(XMarkIcon, { onClick: closeToast, class: 'size-6 min-w-6 text-black cursor-pointer' }),
    icon: ({ type }: { type: string }) => {
      if (type === 'error') {
        return h(ExclamationTriangleIcon, { class: 'size-6 min-w-6 text-danger' })
      } else if (type === 'success') {
        return h(CheckCircleIcon, { class: 'size-6 min-w-6 text-success' })
      } else if (type === 'warning') {
        return h(ExclamationCircleIcon, { class: 'size-6 min-w-6 text-warning' })
      }
      return null
    }
  })

  return {
    provide: { toast }
  }
})
